import clsx from 'clsx'
import { FC, ReactNode } from 'react'
import { Col, Row } from 'react-bootstrap'
import { usePageData } from '../core/PageData'

type AdminPageHeaderProps = {
  /** Page title. Skipped when the shared layout H1 is already on (default). */
  title?: ReactNode
  /** Right-side actions (buttons, filters trigger, etc.). */
  actions?: ReactNode
  className?: string
  /** Force showing an inline title even if the shared heading is on. */
  forceInlineTitle?: boolean
}

/**
 * Reusable list/detail header row for both admin apps.
 * Pair with route-level <PageTitle> (breadcrumb + shared H1 by default).
 * Use this only for actions — or for a custom title when showHeading={false}.
 */
const AdminPageHeader: FC<AdminPageHeaderProps> = ({
  title,
  actions,
  className,
  forceInlineTitle = false,
}) => {
  const { pageShowHeading } = usePageData()
  const showInlineTitle = !!title && (forceInlineTitle || !pageShowHeading)

  if (!showInlineTitle && !actions) {
    return null
  }

  return (
    <Row className={clsx('align-items-center g-3 mb-7 admin-page-header', className)}>
      {showInlineTitle ? (
        <Col xs>
          <h1 className="page-heading admin-page-inline-title fs-22 fw-bolder mb-0">{title}</h1>
        </Col>
      ) : (
        <Col xs className="d-none d-md-block" aria-hidden="true" />
      )}
      {actions ? <Col xs="auto">{actions}</Col> : null}
    </Row>
  )
}

export { AdminPageHeader }
